export enum RatingStorageEnum {
  version = 'RATING_ui_version'
};
